// extracted by mini-css-extract-plugin
module.exports = {"hero":"styles_hero__1GIFS","image":"styles_image__2XG6L","header":"styles_header__36sOv"};